<template>
  <div
    class="w-full flex flex-col gap-3 justify-center items-center min-h-[500px]"
  >
    <el-empty :image-size="200" :description="description"></el-empty>
  </div>
</template>

<script setup>
import { ElEmpty } from "element-plus";
import { defineProps, computed } from "vue";

const props = defineProps({
  description: {
    type: [String, null],
    default: "",
  },
});

const description = computed(() => props.description);
</script>

<style lang="scss" scoped></style>
